// In-memory cache for paginated list pages (Browse, CategoryPage) so that
// returning via Back/Forward restores the already-loaded items, page number
// and sort — instead of remounting, refetching page 1, and losing the user's
// place deep in a "load more" feed. Paired with the ScrollManager which
// restores the pixel scroll position once the content height is back.
//
// Kept in module memory (not sessionStorage) because listing payloads can be
// large; it only needs to survive within-session SPA navigation, which module
// state does. Bounded to the most-recent entries to avoid unbounded growth.

const MAX_ENTRIES = 12;
const store = new Map(); // key -> { listings, total, page, sort, ts }

export const getListCache = (key) => store.get(key) || null;

export const setListCache = (key, value) => {
  // Refresh insertion order (Map preserves it) then trim oldest.
  if (store.has(key)) store.delete(key);
  store.set(key, { ...value, ts: Date.now() });
  while (store.size > MAX_ENTRIES) {
    const oldest = store.keys().next().value;
    store.delete(oldest);
  }
};

export const clearListCache = () => store.clear();
